import BaseDialog from "@/components/BaseDialog";

// 触发详情
export function tagFieldsConfigModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./tiggerInfo'),
        options: {
            width: '70%',
            title: '触发详情',
            closeOnClickModal:false,
            customClass: 'setMinPadding'
        },
        props,
        cbs,
    })
}


// 运行记录列表页-运行详情 弹窗
export function runRecordDetailModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./runRecordDetailModal.vue'),
        options: {
            width: '80%',
            title: '运行详情',
            top:'5vh',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}
